import React from "react";
import {
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import logo from "../../logo-succession-now.png";
import Shape from "../../shape.png";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";

import RobotoLight from "../../assets/font/Roboto-Light.ttf";
import RobotoRegular from "../../assets/font/Roboto-Regular.ttf";
import RobotoItalic from "../../assets/font/Roboto-Italic.ttf";
import RobotoMedium from "../../assets/font/Roboto-Medium.ttf";
import RobotoBold from "../../assets/font/Roboto-Bold.ttf";

Font.register({ family: "RobotoLight", src: RobotoLight });
Font.register({ family: "RobotoRegular", src: RobotoRegular });
Font.register({ family: "RobotoItalic", src: RobotoItalic });
Font.register({ family: "RobotoMedium", src: RobotoMedium });
Font.register({ family: "RobotoBold", src: RobotoBold });

const CompanyContextSummeryReport = ({ user, companyLogo,list }) => {
  const { t } = useTranslation();
  const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontFamily: "Helvetica",
      fontSize: 9,
      color: "#334155",
      backgroundColor: "#f1f5f9",
    },

    table: {
      width: "100%",
      flexDirection: "column",
      backgroundColor: "#ffffff",
      borderRadius: 10,
      overflow: "hidden",
    },

    thead: {
      width: "100%",
      flexDirection: "row",
      backgroundColor: "#000000",
      color: "#ffffff",
    },
    th: {
      paddingVertical: 7,
      paddingHorizontal: 6,
      justifyContent: "center",
    },

    tbody: { flexDirection: "column", width: "100%" },
    tr: {
      flexDirection: "row",
      width: "100%",
    },
    rowAlt: { backgroundColor: "#f6f9fb" },

    td: {
      paddingVertical: 8,
      paddingHorizontal: 8,
      justifyContent: "center",
    },

    c1: { width: "13%" },
    c2: { width: "14%" },
    c3: { width: "12%" },
    c4: { width: "15%" },
    c5: { width: "11.5%" },
    c6: { width: "11.5%" },
    c7: { width: "7.5%" },
    c8: { width: "7%" },
    c9: { width: "9%" },

    thData: {
      fontFamily: "RobotoBold",
      fontSize: 9,
      color: "#ffffff",
      textAlign: "center",
    },
    tdData: { fontFamily: "RobotoRegular", fontSize: 8.5, color: "#334155" },
    tdCenter: { textAlign: "center" },
    tdLeft: { textAlign: "left" },

    tealLight: { backgroundColor: "#7dd3fc" },
    tealMid: { backgroundColor: "#99f6e4" },
  });  

  return (
    <>
      {/* Cover Page */}
      <Page
        size="A4"
        orientation="landscape"
        style={{
          padding: 20,
          fontFamily: "RobotoRegular",
          lineHeight: 1.2,
          fontSize: 9,
          color: "#334155",
          backgroundColor: "#f1f5f9",
          position: "relative",
          zIndex: 0,
        }}
      >
        <View
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }}
          fixed
        >
          <View
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              right: 0,
              width: "100%",
              height: 160,
              zIndex: -1,
              opacity: 0.1,
            }}
          >
            <Image style={{ objectFit: "cover" }} src={Shape} />
          </View>
          <View
            style={{
              position: "absolute",
              width: "100%",
              left: 0,
              bottom: -10,
              right: 0,
              height: 160,
              zIndex: -1,
              opacity: 0.075,
            }}
          >
            <Image style={{ objectFit: "contain" }} src={logo} />
          </View>
        </View>

        <View style={{ position: "absolute", right: 30, top: 30 }}>
          <Image
            style={{ width: 120, height: 24, objectFit: "contain" }}
            src={logo}
          />
        </View>

        <View
          style={{
            paddingBottom: 20,
            width: "100%",
            height: "90%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <View
            style={{
              paddingBottom: 20,
              margin: "auto",
              display: "flex",
              alignItems: "center",
            }}
          >
            <View
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Image
                style={{ width: 360, height: 120, objectFit: "contain" }}
                src={companyLogo}
              />
            </View>

            <View
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 15,
              }}
            >
              <Text
                style={{
                  fontFamily: "RobotoBold",
                  fontSize: 20,
                  textTransform: "capitalize",
                  textAlign: "center",
                }}
              >
                Company Name: {user?.company_name}
              </Text>
            </View>

            <View
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 15,
              }}
            >
              <Text
                style={{
                  fontFamily: "RobotoBold",
                  fontSize: 12,
                  textTransform: "uppercase",
                  color: "#14b8a6",
                  letterSpacing: 3,
                  textAlign: "center",
                }}
              >
                {t("company_repeat_candidate_overview")}
              </Text>
            </View>
          </View>

          <View
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              marginTop: 5,
              textAlign: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{ display: "flex", flexDirection: "row", marginTop: 5 }}
            >
              <Text style={{ fontFamily: "RobotoBold", fontSize: 10 }}>
                Date:
              </Text>
              <Text
                style={{
                  fontFamily: "RobotoRegular",
                  fontSize: 10,
                  marginLeft: 2,
                }}
              >
                {moment(new Date()).format("MM/DD/YYYY")}
              </Text>
            </View>
          </View>
        </View>
      </Page>

      {/* Table Page (Static Data) */}
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.table}>
          {/* Header */}
          <View style={styles.thead}>
            <View style={[styles.th, styles.c1]}>
              <Text style={styles.thData}>Candidate Name</Text>
            </View>
            <View style={[styles.th, styles.c2]}>
              <Text style={styles.thData}>Position</Text>
            </View>
            <View style={[styles.th, styles.c3]}>
              <Text style={styles.thData}>Planner</Text>
            </View>
            <View style={[styles.th, styles.c4]}>
              <Text style={styles.thData}>Plan Position</Text>
            </View>
            <View style={[styles.th, styles.c5]}>
              <Text style={styles.thData}>
                Candidate Overall{"\n"}Weighted Score
              </Text>
            </View>
            <View style={[styles.th, styles.c6]}>
              <Text style={styles.thData}>
                Recent Performance{"\n"}Review
              </Text>
            </View>
            <View style={[styles.th, styles.c7]}>
              <Text style={styles.thData}>
                Conditions Of Concern{"\n"}Score
              </Text>
            </View>
            <View style={[styles.th, styles.c8]}>
              <Text style={styles.thData}>
                Potential Predictors{"\n"}Score
              </Text>
            </View>
            <View style={[styles.th, styles.c9]}>
              <Text style={styles.thData}>
                Candidate{"\n"}Retirement Window
              </Text>
            </View>
          </View>

          {/* Body */}
          <View style={styles.tbody}>
            {list.length > 0 &&
              (() => {
                // Utility function to create grouped data
                const createGroupedData = (list) => {
                  const nameGroups = {};
                  const groupedData = [];

                  // Group items by name
                  list.forEach(item => {
                    if (!nameGroups[item.name]) {
                      nameGroups[item.name] = [];
                    }
                    nameGroups[item.name].push(item);
                  });

                  // Add grouping metadata to each item
                  Object.keys(nameGroups).forEach((name, groupIndex) => {
                    nameGroups[name].forEach((item, itemIndex) => {
                      groupedData.push({
                        ...item,
                        isFirstInGroup: itemIndex === 0,
                        isLastInGroup: itemIndex === nameGroups[name].length - 1,
                        groupSize: nameGroups[name].length,
                        groupIndex: groupIndex
                      });
                    });
                  });

                  return groupedData;
                };

                // Utility function for performance review background color
                const getPerformanceReviewBg = (name, currentItem) => {
                  const sameNameItems = list.filter(item => item?.name === name);
                  
                  if (sameNameItems.length < 2) {
                    return "#7dd3fc"; // Default color
                  }
                  
                  const currentPerformanceReviewId = currentItem?.performance_review?._id || null;
                  if (currentPerformanceReviewId === null) {
                    return "#7dd3fc";
                  }
                  
                  const countOfCurrentId = sameNameItems.filter(item => 
                    (item?.performance_review?._id || null) === currentPerformanceReviewId
                  ).length;
                  
                  return countOfCurrentId >= 2 ? "#99f6e4" : "#7dd3fc"; // Highlight or default
                };

                // Utility function for retirement windows background color
                const getRetirementWindowsBg = (name, currentItem) => {
                  const sameNameItems = list.filter(item => item?.name === name);
                  
                  if (sameNameItems.length < 2) {
                    return "#7dd3fc"; // Default color
                  }
                  
                  const currentRetirementWindowId = currentItem?.retirement_windows?._id || null;
                  if (currentRetirementWindowId === null) {
                    return "#7dd3fc";
                  }
                  
                  const countOfCurrentId = sameNameItems.filter(item =>
                    (item?.retirement_windows?._id || null) === currentRetirementWindowId
                  ).length;
                  
                  return countOfCurrentId >= 2 ? "#99f6e4" : "#7dd3fc"; // Highlight or default
                };

                // Create grouped data
                const groupedData = createGroupedData(list);

                // Render the table rows
                return groupedData.map((row, idx) => {
                  const performanceBgColor = getPerformanceReviewBg(row.name, row);
                  const retirementBgColor = getRetirementWindowsBg(row.name, row);

                  return (
                    <React.Fragment key={idx}>
                      {/* Add spacing between groups */}
                      {row.isFirstInGroup && row.groupIndex > 0 && (
                        <View style={[styles.tr, { height: 10, backgroundColor: '#f3f4f6' }]}>
                          <View style={[styles.td, { flex: 1 }]}>
                            <Text style={{ fontSize: 1 }}> </Text>
                          </View>
                        </View>
                      )}

                      {/* Main table row */}
                      <View
                        style={[
                          styles.tr,
                          idx % 2 === 1 ? styles.rowAlt : null,
                          row.isFirstInGroup ? { borderTopWidth: 2, borderTopColor: '#3b82f6' } : null
                        ]}
                        wrap={false}
                      >
                        {/* Name Column */}
                        <View style={[styles.td, styles.c1]}>
                          <Text style={[
                            styles.tdData,
                            styles.tdLeft,
                            row.isFirstInGroup ? { fontWeight: 'bold' } : null
                          ]}>
                            {row.name || "-"}
                          </Text>
                          {row.isFirstInGroup && row.groupSize > 1 && (
                            <Text style={[styles.tdData, { fontSize: 8, color: '#3b82f6' }]}>
                              ({row.groupSize} entries)
                            </Text>
                          )}
                        </View>

                        {/* Position Column */}
                        <View style={[styles.td, styles.c2]}>
                          <Text style={[styles.tdData, styles.tdCenter]}>
                            {row.position || "-"}
                          </Text>
                        </View>

                        {/* Planner Column */}
                        <View style={[styles.td, styles.c3]}>
                          <Text style={[styles.tdData, styles.tdCenter]}>
                            {row.planner || "-"}
                          </Text>
                        </View>

                        {/* Planner Position Column */}
                        <View style={[styles.td, styles.c4]}>
                          <Text style={[styles.tdData, styles.tdCenter]}>
                            {row.planner_position || "-"}
                          </Text>
                        </View>

                        {/* Overall Score - always tealLight */}
                        <View style={[styles.td, styles.c5, styles.tealLight]}>
                          <Text style={[styles.tdData, styles.tdCenter]}>
                            {row.overallWeightScore || "-"}
                          </Text>
                        </View>

                        {/* Performance Review - conditional coloring */}
                        <View style={[styles.td, styles.c6, { backgroundColor: performanceBgColor }]}>
                          <Text style={[styles.tdData, styles.tdCenter]}>
                            {row?.performance_review?.name || "-"}
                          </Text>
                          {row?.performance_review?.name && (
                            <Text style={{ fontSize: 9, textAlign: "center" }}>
                              ({row?.performance_review?.number})
                            </Text>
                          )}
                        </View>

                        {/* Concern Score - always tealLight */}
                        <View style={[styles.td, styles.c7, styles.tealLight]}>
                          <Text style={[styles.tdData, styles.tdCenter]}>
                            {row.concern_score !== undefined ? row.concern_score : "-"}
                          </Text>
                        </View>

                        {/* Predictor Score - always tealLight */}
                        <View style={[styles.td, styles.c8, styles.tealLight]}>
                          <Text style={[styles.tdData, styles.tdCenter]}>
                            {row.predictor_score !== undefined ? row.predictor_score : "-"}
                          </Text>
                        </View>

                        {/* Retirement Windows - conditional coloring */}
                        <View style={[styles.td, styles.c9, { backgroundColor: retirementBgColor }]}>
                          <Text style={[styles.tdData, styles.tdCenter]}>
                            {row.retirement_windows?.name || "-"}
                          </Text>
                        </View>
                      </View>
                    </React.Fragment>
                  );
                });
              })()}
          </View>

        </View>
      </Page>
    </>
  );
};

export default CompanyContextSummeryReport;